import Axios from "axios";

export const GetNumFacBCFrs = (a, b, c, d, e) => {
  return (dispatch) => {
    Axios.get(
      `https://www.24-crm.tn/webservice/api/BCDVCLIs?typpe=CF&codep=&coddos=${a}&serveur=${b}&user=${c}&pwd=${d}&database=${e}`
    ).then((response) => {
      dispatch({ type: "NUMFAC_BCFRS", payload: response.data });
    });
  };
};
